/* 布局 */
//前台
import Layout from "@views/layout";

const expertstationedromotionaccountRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "expertstationedromotionaccount/list",
        name: "EXPERTSTATIONEDROMOTIONACCOUNT",
        meta: {
            title: "驻站专家宣传账号",
            keepAlive:true
        },
        component: () => import("@views/business/expertstationedromotionaccount/index.vue"),
    },
        ],
};

export default expertstationedromotionaccountRouter;
